export enum WebSocketStatusEnum {
  Idle = 'idle',
  Connecting = 'connecting',
  Reconnecting = 'reconnecting',
  Open = 'open',
  Closing = 'closing',
  Closed = 'closed',
  Error = 'error',
}
